import React from "react";
import "./styles.css";
import Text from "../typography/text";
import { colors } from "../../theme/colors";

const Tags = ({ textColor, tagBackground, tagText, size = "default" }) => {
  const isSmall = size === "small";
  return (
    <div
      style={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        height: "100%",
      }}
    >
      <div
        className={`tags-container ${isSmall ? "tags-container--small" : ""}`}
        style={{ backgroundColor: colors[tagBackground] }}
      >
        <Text variant={isSmall ? "tinyText" : "smallText"} color={textColor}>
          {tagText}
        </Text>
      </div>
    </div>
  );
};

export default Tags;
